import React, { useState } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'
import { formatPhoneNumber } from '../../../services/utils'

export const UserInformation = ({ userInfo, handleModal }) => {
  const [userInfoFirst] = useState(userInfo.first || 'N/A')
  const [userInfoLast] = useState(userInfo.last || 'N/A')
  let dataArray = [
    [
      { id: 3, title: 'Email', value: userInfo.email },
      { id: 4, title: 'Phone', value: formatPhoneNumber(userInfo.phone) }
    ]
  ]
  const renderUserInformation = () => {
    const cardContent = dataArray && dataArray.map((arrayEntry, index) => {
      const mappedArrayEntry = (
        <div key={index}>
          <div className='mt20'>
            {
              arrayEntry.map(entry => {
                let headerFormat = 'tal fz13 c-darkgray fw600'
                return (
                  <div key={entry.id} className='df mb10 tal'>
                    <div>
                      <div className={headerFormat}>
                        {entry.title}
                      </div>
                      <div className='fz15'>
                        {entry.value}
                      </div>
                    </div>
                  </div>)
              })}
          </div>
          {index < (dataArray.length - 1) && <div className='bb1-s-lightgray hide-tablet pt10 mb10' />}
        </div>
      )
      return mappedArrayEntry
    })
    return (
      <div className='df mt10 mb10'>
        <div className='w100%'>
          {cardContent}
        </div>
      </div>
    )
  }

  return (
    <Widget title={`${userInfoFirst} ${userInfoLast}'s information`} button={<Button text='Edit information' clickHandler={handleModal} />}>
      {renderUserInformation()}
    </Widget>
  )
}
export default UserInformation